// removed by extract-text-webpack-plugin
module.exports = {"MenuItem":"_1WO3BpNozffg5g2AC9Hhkc","ItemIcon":"_3jXumGHktelHM14QSh7Mo5","MenuItemSelected":"TsqsMpP80gT5Duu3e-e2V","MenuItemWrapper":"-WIP9IK7xOI0_dOzY3oWV","subTitleText":"_2ISNN7N3ehlyDZt3RP-uv8","MenuSubTitle":"_1gKxGIT2CcC6Q4pjEISL1z","MenuSubItem":"IBqpzM4DB29XR8taOHHHK","MenuSubItemSelected":"_2G4X1VKnxNb_ZSlB99KeSK","MenuSubSubItem":"_3RW_MndF7KCQPrWaa34X4u","MenuSubSubItemSelected":"_1vxgUacQoyVMylx_jn2Mo5"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Menu/style.css
// module id = 416
// module chunks = 0